import menuInit from './menu';
import navbarInit from './navbar';

window.onload = async () => {
  if (document.getElementsByClassName('slider').length) {
    import('./slider').then((module) => module.default());
  }
  if (document.getElementsByClassName('upload').length) {
    import('./upload').then((module) => module.default());
  }
};

document.addEventListener('DOMContentLoaded', () => {
  import(/* webpackPrefetch: true */ './icons');
  menuInit();
  navbarInit();
});
